<div class="workSpace" [ngClass]="{'w3-disabled': !editTable}">
  <!--nombre y filtro-->
  <div class="headersTab">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-quarter padreizquierda">
      <div class="w3-row hijoizquierda">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
            'menu.'+dataService.moduleSelect | translate }} </b> </span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{
          'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <!--Filtros-->
    <div class="w3-rest">
      <div class="w3-quarter">
        <app-filters
            [name]="'filtros.periodo' | translate"
            [array]="years"
            [typeFilter]="Filters.YEAR"
            (eventClick)="yearChange($event)"
            [click]="false"
          ></app-filters>
      </div>
      <div class="w3-quarter">
          <app-filters
          [name]="'filtros.lider' | translate"
          [typeFilter]="Filters.SUCURSALES"
          (eventClick)="changeResponsibles($event)"
          [click]="false"
          [array]="viewResponsables"
          [consolidado]="viewAllresponsibles"
          />
      </div>
      <div class="w3-quarter">
          <app-filters
          [name]="'filtros.res' | translate"
          [typeFilter]="Filters.SUCURSALES"
          (eventClick)="changeResponsiblesActivity($event)"
          [click]="false"
          [array]="viewResponsablesActivity"
          [consolidado]="viewAllresponsiblesActivity"
          />
      </div>
      <div class="w3-rest padreizquierda w3-right">
        <div class="w3-row hijoizquierda">
          <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="borrarFiltro()" style="transform: scale(0.9);" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
              <img src="./../../../../assets/img/eraser.png">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="workSpaceTab" id="componentGantt">
    <div class="w3-right">
      <div class="botonesModales" style="margin-top: 2vh; margin-bottom: 2vh; margin-left: 2vw;">

        <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="openModal(1)">
          <span>{{'acciones.create-plan' | translate}}</span>
          <mat-icon class="iconoMen">add_circle_outline</mat-icon>
        </div>
      </div>

    </div>

    <div class="w3-scroll" style="height: 75%; width: 100%; ">
      @if (viewTablero) {
        <!-- <app-gantt [data]="ganttComponent"/> -->
        <table class="w3-table" style="overflow: scroll;">
          <thead>
						<tr class="w3-table-titleLow w3-center ">
              <th class="encabezados tresPun" style="line-height: 1.2;">
                @if (mostrarAllPlanes) {
                  <mat-icon (click)="mostrarTodasLosPlanes()" class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.alta-actas.ocultarTodo' | translate}}" matTooltipPosition="left" >expand_less</mat-icon>
                }@else {
                  <mat-icon (click)="mostrarTodasLosPlanes()"  class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.alta-actas.mostrarTodo' | translate}}" matTooltipPosition="left" >expand_more</mat-icon>
                }
              </th>
							<th class="encabezados w3-border-right-balance anchosColumnas stikyColumnLeft">{{ 'cues.proyectos.proyecto-actividad' | translate}}</th>
							<th class="encabezados w3-border-right-balance anchosColumnas">{{ 'cues.proyectos.proyecto-responsible' | translate}}</th>
							<th class="encabezados w3-border-right-balance anchosColumnas">{{ 'cues.proyectos.fecha-inicio-tab' | translate}}</th>
							<th class="encabezados w3-border-right-balance anchosColumnas">{{ 'cues.proyectos.fecha-fin-tab' | translate}}</th>
							<th class="th-gantt encabezados">
								<div class="gantt-ruler">
									@for (mes of meses; track $index) {
										<div class="gantt-mes-label" [style.width]="getMesWidth(mes)">{{mes.name}}</div>
									}
								</div>
							</th>
              @for (adicional of aditionals; track $index) {
                <th class="encabezados w3-border-right-balance textoOverFlow" style="padding: 0vw 10px; cursor: pointer; line-height: 1.2;">
                  <span [matMenuTriggerFor]="manuEdicionAd">{{adicional.nombre}}</span>
                </th>
                <mat-menu class="w3-medium" #manuEdicionAd="matMenu">
                  <button (click)="openModal(3, adicional)" class="mat-menu-item" mat-menu-item>
                    <mat-icon [ngStyle]="{'color':'gray'}">edit</mat-icon>
                    <span>{{'menu.Editar' | translate}}</span>
                  </button>
                  <button (click)="deleteAdicional(adicional)" class="mat-menu-item" mat-menu-item>
                    <mat-icon [ngStyle]="{'color':'gray'}">delete</mat-icon>
                    <span>{{'menu.eliminar' | translate}}</span>
                  </button>
                </mat-menu>
              }
              <th class="encabezados w3-border-right-balance anchosColumnas">
                <mat-icon class="iconoMen colorBotonDeNuevo" (click)="openModal(3)" [matTooltip]="'cues.proyectos.aditional' | translate">add_circle_outline</mat-icon>
              </th>
						</tr>
          </thead>
          <tbody>
            @for (planes of gant; track $index) {
              <tr class="w3-table-trtd w3-white">
                <td class="borderAllLow " style="min-width: 7vw;">
                  @if (planes.check) {
                    <mat-icon class="iconoMen w3-button" (click)="mostrarPlanes(planes)" matTooltip="{{'gestion.formulacion.alta-actas.ocultar' | translate}}" matTooltipPosition="left">expand_less</mat-icon>
                  }@else { 
                    <mat-icon class="iconoMen w3-button" (click)="mostrarPlanes(planes)" matTooltip="{{'gestion.formulacion.alta-actas.mostrar' | translate}}" matTooltipPosition="left">expand_more</mat-icon>
                  }
                  <mat-icon (click)="openModal(2, planes)" class="iconoMen w3-button">add_circle_outline</mat-icon>
                  <mat-icon (click)="editItem(planes)" class="iconoMen w3-button">edit</mat-icon>
                  <mat-icon (click)="deleteItem(planes)" class="iconoMen w3-button">delete</mat-icon> 
                </td>
                <td class="borderAllLow marginsH textoOverFlow stikyColumnLeftWhite" [matTooltip]="planes.name" style="max-width: 13vw;">
                  <span>{{planes.name}}</span>
                </td>
                <td class="borderAllLow marginsH textoOverFlow " [matTooltip]="planes.responsible?.role_name" style="max-width: 10vw;">
                  <span>{{planes.responsible?.role_name}}</span>
                </td>
                <td class="borderAllLow marginsH w3-center">
                  <span [matTooltip]="planes.startDate"> {{planes.startDate}} </span>
                </td>
                <td class="borderAllLow marginsH w3-center">
                  <span [matTooltip]="planes.endDate"> {{planes.endDate}} </span>
                </td>
                <td class="borderAllLow td-gantt ">
                  <div class="gantt-track">
                    <div class="gantt-grid-lines"></div>
                    <div class="gantt-bar gantt-bar-plan"
                      [style.left]="getBarLeft(planes.start_date)"
                      [style.width]="getBarWidth(planes.start_date, planes.end_date)">
                    </div>
                  </div>
                </td>
                @for (adicional of planes.adicionales; track $index) {
                  <td class="borderAllLow"> <br> </td>
                }
                <td class="borderAllLow"> <br> </td>
              </tr>
              @if (planes.check) {
                @for (actividad of planes.activities; track $index) {
                  @if (mostrarActividad(actividad)) {
                    <tr class="w3-table-trtd w3-white">
                      <td class="borderAllLow">
                        <mat-icon (click)="editItem(actividad)" class="w3-button iconoMen">edit</mat-icon>
                        <mat-icon (click)="deleteItem(actividad)" class="iconoMen w3-button">delete</mat-icon> 
                      </td>
                      <td class="borderAllLow marginsH stikyColumnLeftWhite">
                        <span [matTooltip]="actividad.name">{{actividad.name}}</span>
                      </td>
                      <td class="borderAllLow marginsH">
                        <span [matTooltip]="actividad.responsible?.role_name">{{actividad.responsible?.role_name}}</span>
                      </td>
                      <td class="borderAllLow marginsH w3-center">
                        <span [matTooltip]="actividad.startDate"> {{actividad.startDate}} </span>
                      </td>
                      <td class="borderAllLow marginsH w3-center">
                        <span [matTooltip]="actividad.endDate"> {{actividad.endDate}} </span>
                      </td>
                      <td class="borderAllLow td-gantt">
                        <div class="gantt-track">
                          <div class="gantt-grid-lines"></div>
                          <div class="gantt-bar gantt-bar-act"
                            [style.left]="getBarLeft(actividad.start_date)"
                            [style.width]="getBarWidth(actividad.start_date, actividad.end_date)">
                          </div>
                        </div>
                      </td>
                      @for (adicional of planes.adicionales; track $index) {
                        <td class="borderAllLow"> <br> </td>
                      }
                      <td class="borderAllLow"> <br> </td>
                    </tr>
                  }
                }
              }
            }
          </tbody>
        </table>
      }@else {
        <app-skeleton-table [columnas]="13" [filas]="10" />
      }
    </div>
  </div>
</div>

<app-modal [isOpen]="modalProjects" (close)="closeModal()">
  <div modal-header>
    @if (!edit) {
      <span>{{'cues.proyectos.agregar-proyecto' | translate}}</span>
    }@else {
      <span>{{'cues.proyectos.editar-proyecto' | translate}}</span>
    }
  </div>

  <div modal-body>
    <div class="w3-row" [formGroup]="formProy">

      <div class="form-group">
        <label for="pregunta" class="form-label">
            {{'cues.proyectos.selec-preg' | translate}} *
        </label>
        <select id="pregunta" class="contentSelect anchosInputs" formControlName="questionId" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          @for (elem of questionsSelect; track elem.element) {
            <optgroup [label]="delimitOptions(elem.element)" [title]="elem.element">
              @for (opt of elem.questions; track opt.id) {
                @if (questionExist(opt.id)) {
                  <option class="textoOverFlow" value="{{opt.id}}" title="{{opt.descripcion}}">
                    {{delimitOptions(opt.descripcion)}}
                  </option>
                }
              }
            </optgroup>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="nombre" class="form-label">
            {{'cues.proyectos.nombre' | translate}} *
        </label>
        <input type="text" id="nombre" class="form-input anchosInputs" formControlName="name" required>
      </div>

      <div class="form-group">
        <label for="responsible" class="form-label">
            {{'cues.proyectos.selec-responsible' | translate}}
        </label>
        <select id="responsible" class="contentSelect anchosInputs" formControlName="responsible" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          @for (elem of responsibles; track elem.element) {
            <option [value]="elem.id"> {{elem.role_name}} </option>
          }
        </select>
      </div>

      </div>
  </div>

  <div modal-footer>
    <div class="w3-right">
      <div class="botonesModales" [ngClass]="{'w3-disabled': !this.formProy.valid}">
        <button
          mat-flat-button
          color="success"
          (click)="saveInformationProyects()"
          style="height: 4vh;"
        >
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="closeModal()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal [isOpen]="modalActivities" (close)="closeModal()">
  <div modal-header>
    @if (!edit) {
      <span>{{'cues.proyectos.agregar-actividad' | translate}}</span>
    }@else {
      <span>{{'cues.proyectos.editar-actividad' | translate}}</span>
    }
  </div>
  
  <div modal-body>
    <div class="w3-row" [formGroup]="formActi">
      <div class="form-group">
        <label for="nombre" class="form-label">
            {{'cues.proyectos.nombre-actividad' | translate}} *
        </label>
        <input type="text" id="nombre" class="form-input anchosInputs" formControlName="name" required>
      </div>

      <div class="form-group">
        <label for="responsible" class="form-label">
            {{'cues.proyectos.selec-responsible' | translate}}
        </label>
        <select id="responsible" class="contentSelect anchosInputs" formControlName="responsible" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          @for (elem of responsibles; track elem.element) {
            <option [value]="elem.id"> {{elem.role_name}} </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="fechaIni" class="form-label"> {{'cues.proyectos.fecha-inicio' | translate}} *</label>
        <input id="fechaIni" type="date" class="form-input anchosInputs" formControlName="start_date">
      </div>

      <div class="form-group">
        <label for="fechaFin" class="form-label"> {{'cues.proyectos.fecha-inicio' | translate}} *</label>
        <input id="fechaFin" type="date" class="form-input anchosInputs" formControlName="end_date"  min="{{formActi.controls['start_date'].value}}">
      </div>

    </div>
  </div>

  <div modal-footer>
    <div class="w3-right">
      <div class="botonesModales" [ngClass]="{'w3-disabled': !this.formActi.valid}">
        <button
          mat-flat-button
          color="success"
          (click)="saveInformationActivities()"
          style="height: 4vh;"
        >
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="closeModal()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal [isOpen]="modalAdittional" (close)="closeModal()">
  <div modal-header>
    @if (!edit) {
      <span>{{'cues.proyectos.agregar-actividad' | translate}}</span>
    }@else {
      <span>{{'cues.proyectos.editar-actividad' | translate}}</span>
    }
  </div>

  <div modal-body>
    <div class="w3-row" [formGroup]="formAdit">

      @if(formAdit.hasError('isValid')){
        <div class="alinLeft w3-row"  style="font-size: 8pt; color: red">{{'gestion.formulacion.alta-actas.nombreExis'|translate}}</div>
      } 
      <div class="form-group">
        <label for="name" class="form-label"> {{'cues.proyectos.nombre-adicional' | translate}} *</label>
        <input id="name" type="text" class="form-input anchosInputs" formControlName="name">
      </div>

    @if (!gantAditionalId) {
      <div class="form-group">
        <label for="type" class="form-label">
            {{'cues.proyectos.selec-tipo' | translate}} *
        </label>
        <select id="type" class="contentSelect anchosInputs" formControlName="type" value="">
          <option value="" disabled> {{'cues.proyectos.selec' | translate}} </option>
          <option value="text"> <span [matTooltip]="'cues.proyectos.adicional-1-etiqueta' | translate">
              {{'cues.proyectos.adicional-1' | translate}}</span> </option>
          <!-- <option value="moneda" [matTooltip]="'cues.proyectos.adicional-2-etiqueta' | translate">
            {{'cues.proyectos.adicional-2' | translate}} </option> -->
          <option value="file" [matTooltip]="'cues.proyectos.adicional-3-etiqueta' | translate">
            {{'cues.proyectos.adicional-3' | translate}} </option>
          <!-- <option value="nota" [matTooltip]="'cues.proyectos.adicional-4-etiqueta' | translate">
            {{'cues.proyectos.adicional-4' | translate}} </option> -->
        </select>
      </div>
    }
    </div>
  </div>

  <div modal-footer>
    <div class="w3-right">
      <div class="botonesModales" [ngClass]="{'w3-disabled': !this.formAdit.valid}">
        <button
          mat-flat-button
          color="success"
          (click)="saveInformationAditional()"
          style="height: 4vh;"
        >
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="closeModal()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>